import styled from "@emotion/styled";

export const CardContainer = styled.div<{
  isSelected: boolean;
  isHovered: boolean;
}>`
  background: white;
  border: ${({ isSelected, isHovered }) =>
    isSelected
      ? "2px solid #10b981"
      : isHovered
        ? "1px solid #d1d5db"
        : "1px solid #e5e7eb"};
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${({ isSelected, isHovered }) =>
    isSelected
      ? "0 4px 20px rgba(16, 185, 129, 0.15)"
      : isHovered
        ? "0 4px 12px rgba(0, 0, 0, 0.08)"
        : "0 1px 3px rgba(0, 0, 0, 0.05)"};
  display: flex;
  flex-direction: column;
  height: fit-content;
  margin-bottom: 12px;
  position: relative;
  transform: ${({ isHovered }) => (isHovered ? "translateY(-4px)" : "none")};
`;

export const SelectedBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  background: #10b981;
  color: white;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
`;

export const CardHeader = styled.div<{ isSelected: boolean }>`
  padding: 16px;
  background: ${({ isSelected }) =>
    isSelected
      ? "linear-gradient(90deg, #f0fdf4 0%, #ecfdf5 100%)"
      : "#ffffff"};
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CheckboxWrapper = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
`;

export const StyledCheckbox = styled.div<{ isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: ${({ isSelected }) =>
    isSelected ? "2px solid #10b981" : "2px solid #d1d5db"};
  background: ${({ isSelected }) => (isSelected ? "#10b981" : "white")};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
`;

export const ProductInfo = styled.div`
  /* Container for text info */
`;

export const ProductTitle = styled.div<{ isSelected: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${({ isSelected }) => (isSelected ? "#065f46" : "#1f2937")};
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ProductMeta = styled.div`
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PriceBadge = styled.div`
  background: #f8fafc;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PriceLabel = styled.span`
  font-size: 9px;
  text-transform: uppercase;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.025em;
`;

export const StrikethroughPrice = styled.span`
  text-decoration: line-through;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
`;

export const DiscountedPrice = styled.span`
  color: #10b981;
  font-weight: 700;
  font-size: 13px;
`;

export const DiscountLabelMinimal = styled.span`
  font-size: 8px;
  background: #10b981;
  color: white;
  padding: 1px 4px;
  border-radius: 4px;
  font-weight: 800;
  margin-left: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const CardContent = styled.div`
  padding: 16px;
`;

export const CoreInfoRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: white;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FallbackImage = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
`;

export const DiscountSection = styled.div`
  flex: 1;
`;

export const DiscountLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const DiscountRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px;
  background: #f8fafc;
  border-radius: 8px;
`;

export const StyledSelect = styled.select`
  min-width: 110px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: white;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  padding-right: 32px;

  &:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  }
`;

export const InputWrapper = styled.div<{ width?: string }>`
  position: relative;
  width: ${({ width }) => width || "150px"};
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px 12px 10px 40px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: white;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    opacity: 1;
    height: auto;
  }
`;

export const CurrencySymbol = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 14px;
`;

export const NewPriceBadge = styled.div`
  font-size: 12px;
  color: #6b7280;
  background: #f9fafb;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  margin-left: 52px;

  span {
    font-weight: 600;
    color: #10b981;
  }
`;

export const VariationsSection = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const VariationsHeader = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const VariationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
`;

export const VariationCard = styled.div`
  background: #f9fafb;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  transition: all 0.2s;
`;

export const VariationRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const VariationInfo = styled.div`
  flex: 1;
`;

export const VariationTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
`;

export const VariationMeta = styled.div`
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const VariationControls = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const VariationSelect = styled.select`
  width: 70px;
  padding: 8px 10px 8px 8px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 24px;

  &:focus {
    border-color: #10b981;
  }
`;

export const VariationInput = styled.input`
  width: 100px;
  padding: 8px 8px 8px 34px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  outline: none;

  &:focus {
    border-color: #10b981;
  }
`;

export const VariationCurrency = styled.div`
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 12px;
`;

export const VariationPricePreview = styled.div`
  margin-top: 8px;
  font-size: 11px;
  color: #6b7280;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:last-child {
    font-weight: 600;
    color: #10b981;
  }
`;

export const NoVariations = styled.div`
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
  border: 1px dashed #e5e7eb;
`;

export const ExpandHint = styled.div`
  margin-top: 16px;
  padding: 10px;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
  }
`;

// --- DealProducts Page Styles ---

export const StatsBar = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const StatCard = styled.div`
  flex: 1;
  min-width: 200px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
`;

export const StatTitle = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
`;

export const StatValue = styled.div<{ color?: string }>`
  font-size: 28px;
  font-weight: 700;
  color: ${({ color }) => color || "#1f2937"};
`;

export const ControlBar = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
`;

export const ControlContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const LeftControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 42px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 14px;
  color: #1f2937;
  outline: none;
  transition: all 0.2s;

  &:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
`;

export const FilterWrapper = styled.div`
  position: relative;
  min-width: 200px;

  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    z-index: 1;
  }
`;

export const CategorySelect = styled.select`
  width: 100%;
  padding: 12px 16px 12px 36px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 14px;
  color: #1f2937;
  outline: none;
  cursor: pointer;
  appearance: none;

  &:focus {
    border-color: #10b981;
  }
`;

export const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ViewToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f4f6;
  padding: 6px;
  border-radius: 8px;
`;

export const ViewButton = styled.button<{ active: boolean }>`
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: ${({ active }) => (active ? "white" : "transparent")};
  color: ${({ active }) => (active ? "#1f2937" : "#6b7280")};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  box-shadow: ${({ active }) =>
    active ? "0 2px 4px rgba(0,0,0,0.1)" : "none"};
`;

export const SelectAllButton = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
  }
`;

export const LoadingContainer = styled.div`
  padding: 60px 20px;
  text-align: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #f3f4f6;
  border-top-color: #10b981;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  padding: 60px 20px;
  text-align: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const EmptyIcon = styled.div`
  width: 60px;
  height: 60px;
  background: #f9fafb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #9ca3af;
`;

export const ProductsGrid = styled.div<{ viewMode: "list" | "grid" }>`
  display: ${({ viewMode }) => (viewMode === "grid" ? "grid" : "flex")};
  grid-template-columns: ${({ viewMode }) =>
    viewMode === "grid" ? "repeat(auto-fill, minmax(350px, 1fr))" : "none"};
  flex-direction: ${({ viewMode }) => (viewMode === "list" ? "column" : "row")};
  gap: ${({ viewMode }) => (viewMode === "grid" ? "20px" : "0")};
  margin-bottom: 120px;
`;

export const StickyFooter = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e5e7eb;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
`;

export const SelectedInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CountBadge = styled.div`
  background: #f0fdf4;
  padding: 12px 20px;
  border-radius: 10px;
  border: 1px solid #d1fae5;
`;

export const CountLabel = styled.div`
  font-size: 14px;
  color: #065f46;
  margin-bottom: 4px;
`;

export const CountValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #10b981;
`;

export const SelectionMessage = styled.div`
  font-size: 14px;
  color: #6b7280;
  max-width: 400px;
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
